import { APP_INITIALIZER, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactSelfServiceFormsService } from './contact-self-service-forms.service';

export function initializeContactSelfServiceConfig(
  contactSelfServiceFormsService: ContactSelfServiceFormsService
): () => Observable<any> {
  return () => contactSelfServiceFormsService.getDomainAndSiteKey();
}

export const CONTACT_SELF_SERVICE_PROVIDERS: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: initializeContactSelfServiceConfig,
    deps: [ContactSelfServiceFormsService],
    multi: true,
  },
];
